// extracted by mini-css-extract-plugin
export default {"showMoreButton":"ShowMoreButton_showMoreButton__ql0+T","icon":"ShowMoreButton_icon__c5p3c"};